import * as React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { LOCALES } from 'utils/locales'
import Select from '../components/Select'

const data = Object.keys(LOCALES).map(locale => ({
  text: LOCALES[locale],
  value: locale,
}))

class SelectLang extends React.PureComponent {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object,
    locale: PropTypes.string,
    overlayClassName: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  }

  static defaultProps = {
    locale: 'en',
    match: {},
    overlayClassName: '',
  }

  _handleChange = locale => {
    const { history, match } = this.props
    const { url } = match
    const prevUrl = url
      .split('/')
      .slice(2)
      .join('/')

    history.push(`/${locale}/${prevUrl}`)
  }

  render() {
    const { locale, overlayClassName } = this.props

    return (
      <Select
        options={data}
        width="130px"
        defaultValue={locale}
        overlayClassName={overlayClassName}
        onChange={this._handleChange}
      />
    )
  }
}

export default withRouter(
  connect(state => ({
    locale: state.i18n.locale,
  }))(SelectLang)
)
